<template>

  <div

    ref="rootRef"

    class="emoji-picker-popover"

    role="dialog"

    :aria-label="t('kanban.emoji.pickerAria')"

    @click.stop

  >

    <div class="emoji-picker-tabs">

      <button

        v-for="group in groups"

        :key="group.id"

        type="button"

        class="emoji-picker-tab"

        :class="{ 'emoji-picker-tab--active': activeGroup === group.id }"

        :title="group.name"

        @click="activeGroup = group.id"

      >

        {{ group.icon }}

      </button>

    </div>

    <div class="emoji-picker-grid">

      <button

        v-for="(emoji, idx) in activeEmojis"

        :key="`${activeGroup}-${idx}-${emoji}`"

        type="button"

        class="emoji-picker-item"

        :title="emoji"

        @click="pick(emoji)"

      >

        {{ emoji }}

      </button>

    </div>

  </div>

</template>



<script setup>

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import { useI18n } from 'vue-i18n'



const { t } = useI18n()



const emit = defineEmits(['select', 'close'])



const rootRef = ref(null)

const activeGroup = ref('smileys')



const EMOJI_GROUPS = [

  {

    id: 'smileys',

    icon: '😀',

    emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '🥲', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😮‍💨', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '🥸', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱']

  },

  {

    id: 'gestures',

    icon: '👋',

    emojis: ['👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪', '🦾', '🦿']

  },

  {

    id: 'hearts',

    icon: '❤️',

    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '♥️', '💋', '💌', '💐', '🌹', '🌷', '🌸', '💮', '🏵️']

  },

  {

    id: 'objects',

    icon: '💼',

    emojis: ['💼', '📁', '📂', '📅', '📆', '📇', '📈', '📉', '📊', '📋', '📌', '📍', '📎', '📏', '📐', '✂️', '🔒', '🔓', '🔑', '🔨', '⚙️', '🔧', '💡', '🔋', '🔌', '💻', '🖥️', '📱', '☎️', '📞', '📧', '✉️', '📩', '📨', '📤', '📥', '📦', '📫', '📪', '📬', '📭', '📮', '🗳️', '✏️', '📝', '💬', '💭', '🗨️', '🗯️', '💤']

  },

  {

    id: 'symbols',

    icon: '✅',

    emojis: ['✅', '❌', '⭕', '❗', '❓', '‼️', '⁉️', '💯', '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '⚫', '⚪', '🟤', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘', '🔳', '🔲', '▪️', '▫️', '◾', '◽', '⬛', '⬜', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '⏰', '⏳', '⌛', '🕐', '🔔', '🔕', '⭐', '🌟', '✨', '⚡', '🔥', '💥', '💫', '🎉', '🎊']

  }

]



const groups = computed(() =>

  EMOJI_GROUPS.map((g) => ({

    ...g,

    name: t(`kanban.emoji.${g.id}`)

  }))

)



const activeEmojis = computed(() => {

  const g = groups.value.find((x) => x.id === activeGroup.value)

  return g?.emojis || groups.value[0]?.emojis || []

})



const pick = (emoji) => {

  emit('select', emoji)

}



const onDocumentPointerDown = (event) => {

  const el = rootRef.value

  if (el && !el.contains(event.target)) {

    emit('close')

  }

}



onMounted(() => {

  document.addEventListener('pointerdown', onDocumentPointerDown, true)

})



onBeforeUnmount(() => {

  document.removeEventListener('pointerdown', onDocumentPointerDown, true)

})

</script>



<style scoped>

.emoji-picker-popover {

  width: min(320px, calc(100vw - 2rem));

  max-height: 300px;

  display: flex;

  flex-direction: column;

  background: var(--bg-secondary, #fff);

  border: 1px solid var(--border-primary, #e5e7eb);

  border-radius: 4px;

  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);

  overflow: hidden;

}



:global(body.tema_escura) .emoji-picker-popover {

  background: #1f2937;

  border-color: #374151;

}



.emoji-picker-tabs {

  display: flex;

  gap: 2px;

  padding: 8px 8px 4px;

  border-bottom: 1px solid var(--border-primary, #e5e7eb);

  overflow-x: auto;

}



:global(body.tema_escura) .emoji-picker-tabs {

  border-bottom-color: #374151;

}



.emoji-picker-tab {

  flex-shrink: 0;

  width: 36px;

  height: 32px;

  display: flex;

  align-items: center;

  justify-content: center;

  font-size: 1.125rem;

  border: none;

  border-radius: 4px;

  background: transparent;

  cursor: pointer;

  transition: background 0.15s ease;

}



.emoji-picker-tab:hover {

  background: rgba(34, 197, 94, 0.12);

}



.emoji-picker-tab--active {

  background: rgba(34, 197, 94, 0.2);

}



.emoji-picker-grid {

  display: grid;

  grid-template-columns: repeat(8, 1fr);

  gap: 2px;

  padding: 8px;

  overflow-y: auto;

  max-height: 240px;

}



.emoji-picker-item {

  width: 100%;

  aspect-ratio: 1;

  display: flex;

  align-items: center;

  justify-content: center;

  font-size: 1.35rem;

  line-height: 1;

  border: none;

  border-radius: 4px;

  background: transparent;

  cursor: pointer;

  transition: background 0.12s ease, transform 0.1s ease;

}



.emoji-picker-item:hover {

  background: rgba(34, 197, 94, 0.15);

  transform: scale(1.08);

}

</style>

